export default __webpack_public_path__ + "static/media/goodyear.87e00930.png";